import { NewRegistrationSkills } from '../../new-registration.model';

export class CreateCandidateOtherSkillsClass {
    skills?: NewRegistrationSkills[];
    driverLicense?: string[];
    practiceYear?: number;
    practicePosition?: string;
    graduate?: boolean;
}
